import React from "react";

import { Input } from "~/components/input";
import { useScope } from "~/tools/impulse";

import { WidgetFontSize } from "./form-state";

export interface WidgetFontSizeFieldProps {
	name: string;
	fontSize: WidgetFontSize;
}

export const WidgetFontSizeField: React.FC<WidgetFontSizeFieldProps> = ({ name, fontSize }) => {
	const scope = useScope();

	return (
		<Input
			max={WidgetFontSize.max}
			name={name}
			onChange={(event) => fontSize.setInput(event.target.value)}
			placeholder="Auto"
			type="number"
			value={fontSize.getInput(scope)}
		/>
	);
};
